import { render } from "./AudiencesMini.vue?vue&type=template&id=3f8e982d"
import script from "./AudiencesMini.vue?vue&type=script&lang=js"
export * from "./AudiencesMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__